import type { IconData } from '@stacksjs/iconify-core'

export const bookmark: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M424 496h-35.25L256.008 381.19L123.467 496H88V16h336ZM120 48v408.667l135.992-117.8L392 456.5V48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bookmark
